import type { AgentProfile } from '~/core/entities/agentProfile/AgentProfile';
import type { ResultTuple } from '~~/core/helpers/result';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

interface GetProfileBySlugOptions {
	signal?: AbortSignal;
}

interface NuxtAgentProfilesRepository {
	getProfileBySlug: (
		slug: AgentProfile['slug'],
		options?: GetProfileBySlugOptions
	) => Promise<ResultTuple<AgentProfile>>;
}

export const nuxtAgentProfilesRepository: NuxtAgentProfilesRepository = {
	async getProfileBySlug(slug, options) {
		if (!slug) {
			return Result.error({
				message: 'Slug is required.',
				source: 'nuxtAgentProfilesRepository.getProfileBySlug',
				originalErrorObject: new Error('Slug is required.')
			});
		}

		try {
			const response = await $fetch<AgentProfile>(
				`/api/agents/${encodeURIComponent(slug)}/profile`,
				{
					method: 'GET',
					signal: options?.signal
				}
			);

			return Result.ok(response);
		} catch (error) {
			const originalErrorObject = createOriginalErrorObject(error);

			if (originalErrorObject.statusCode === 404) {
				return Result.error({
					message: `Agent profile by slug ${slug} not found`,
					source: 'nuxtAgentProfilesRepository.getProfileBySlug',
					originalErrorObject
				});
			}

			return Result.error({
				message: `Error while fetching the agent profile by slug ${slug}.`,
				source: 'nuxtAgentProfilesRepository.getProfileBySlug',
				originalErrorObject
			});
		}
	}
};
